<script lang="ts">
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<label class="label">
  <slot />
</label>
